import { getLegalLanguage } from './translations';

export const getPrivacyUrl = (language) => {
	const legalLanguage = getLegalLanguage(language);
	return `https://legal.innogames.com/portal/${legalLanguage}/privacy`;
};

export const getTermsAndConditionsUrl = (gameId, language) => {
	const legalLanguage = getLegalLanguage(language);
	return `https://legal.innogames.com/${gameId}/${legalLanguage}/agb`;
};
export const getImprintUrl = (gameId, language) => {
	const legalLanguage = getLegalLanguage(language);
	return `https://legal.innogames.com/${gameId}/${legalLanguage}/imprint`;
};